// First Created - 16 May 2025
// Author - Atul Pandey

import { EyeIcon } from "@heroicons/react/24/solid";

export const setupStatusDetail = {
    subscription: () => (
        <div className=" py-2 border-t text-sm">
            <p className=" text-gray-700 m-1 p-1 py-2 leading-5 border-b">
                Please ask your <span className="font-semibold text-orange-700">Et Admin</span> to help you activate your subscription pack.
            </p>
            <p className=" text-gray-700 m-1 p-1 py-2 leading-5 border-b ">
                The <strong>subscription pack</strong> and the trails which are setup for your <strong>organization</strong> is listed in your profile. Please check the <strong>Packs</strong> under <span className="font-semibold text-orange-700">My Profile Menu</span> to see all the trails!
            </p>
            <p className=" text-gray-700 m-1 p-1 py-2 leading-5 border-b">
                Once the <span className="font-semibold text-orange-700">Et Admin</span> has <strong>activated</strong> your subscription, you can see the activated trails and the sessions in the <span className="font-semibold text-orange-700">Induce</span> arena!
            </p>
            <p className=" text-gray-700 m-1 p-1 py-2 leading-5 border-b">
                The final step is to start one of the <strong>sessions</strong> from any trail which is your primary trail. You will then be able to create <span className="font-semibold text-orange-700">Actions</span> for that trail. Your <strong>activation</strong> is now complete! Keep activating more sessions by clicking on <span className="font-semibold text-orange-700">Start the session</span> button as needed!
            </p>
        </div>
    ),

    subscriptionDone: () => (
        <div>
        <p className="text-xs text-gray-700 m-1 p-1 py-2 leading-5">
        You are all set with your <strong>subscriptions!</strong> Please check the <strong>Packs</strong> under <span className="font-semibold text-orange-700">My Profile Menu</span> to see all the trails!
        </p>
        <p className="text-xs text-gray-700 m-1 p-1 py-2 leading-5 border-t">
        Then go to <strong>Induce</strong> and check if all the <strong>Trails</strong> are listed with all <span className="font-semibold text-orange-700">Sessions</span> there!
        </p>
        <p className="text-xs text-gray-700 m-1 p-1 py-2 leading-5 border-t">
        If you do not see all the trails and sessions, then ask your <span className="font-semibold text-orange-700">Et Admin</span> to assign those trails and sessions!
        </p>
        </div>
    ),

    calendar: () => (
        <div className="text-xs text-gray-700 m-1 p-1">
            <p className="m-1 p-1 py-2 border-b leading-5">Use the instructions below to setup your <strong>Google Calendar</strong> in <span className="font-semibold text-orange-700">Trinity</span>. Trinity will fetch your calendar meetings for you to record / capture your further actions here.</p>
            <ol className="py-2 border-b">
                <li>
                    {/* <p>Go to your profile page by clicking on your pic in the header bar</p> */}
                    <p>Go to your profile page by clicking on your pic at the <strong>top right corner</strong>  of this page</p>
                </li>
                <li>
                    <p>Under the <span className="font-semibold text-orange-700">My Profile</span> Menu, go to My Details</p>
                </li>
                <li>
                    <p>Click on the edit icon to open up the <span className="font-semibold text-orange-700">My Details</span> edit form</p>
                </li>
                <li>
                    <p>Enter your private Google Calendar share url in <span className="font-semibold text-orange-700">Google Calendar</span> iCal URL field and Update</p>
                </li>
            </ol>
            <p className="m-1 p-1 py-2 leading-5"><span className="font-semibold text-orange-700">In Google Calendar </span></p>
            <p className="m-1 p-1 py-2 border-b leading-5">Use the instructions below to find your private Calendar url. <strong>Please do not do this from a public place or a public computer</strong>.</p>
            <ol className="pt-2 border-b">
                <li>
                    <p>Open Google Calendar - https://calendar.google.com or from inside your <strong>Gmail</strong> .</p>
                </li>
                <li>
                    <p>Sroll down on the left side menu and under <span className="font-semibold text-orange-700">My calendars</span> find the calendar you want to share with Trinity.</p>
                </li>
                <li>
                    <p>Hover on that Calendar Name and Click on the <span className="bg-gray-200 rounded p-1 font-bold">⋮</span> icon which will open up a menu box. On this menu box, click on <span className="font-semibold text-orange-700">"Settings and sharing"</span>. This will open up the <strong>Settings</strong> page</p>
                </li>
                <li>
                    <p>On the <strong>Settings</strong> page, keep scrolling down on the right side, till you see the <span className="font-semibold text-orange-700">Integrate calendar</span> section. This is where you will find your Google iCal private url</p>
                </li>
                <li>
                    <p>Scroll down a little further till you see 'Secret address in iCal format' input box, with this icon: <EyeIcon className="h-4 w-4 text-orange-600 inline-block"/> Click on the icon to see your iCal Url. This is the url which you need in Trinity. Copy it from there and paste it in your Calendar setup field in My Details.</p>
                </li>
                <li>
                    <p><strong>You are all set !</strong></p>
                </li>
            </ol>

        </div>
    ),

    calendarDone: () => (
        <p className="text-xs text-gray-700 m-1 p-1 py-2 leading-5">
        You are all set with your <strong>Calendar setup!</strong> Please check the <strong>My Details</strong> under <span className="font-semibold text-orange-700">My Profile Menu</span> to see your calendar details.
        </p>
    ),

    contact: () => (
        <div className="text-xs text-gray-700 m-1 p-1">
            <p className="m-1 p-1 py-2 border-b leading-5">Use the instructions below to setup your <strong>Contacts</strong> in <span className="font-semibold text-orange-700">Trinity</span>. You can then use these contacts to capture your conversations and other engagements with them</p>
            <p className="m-1 p-1 py-2 border-b leading-5">But before you add a <strong>Contact</strong> you need to make sure that you have <span className="font-semibold text-orange-700">Contact Organizations</span> set for your org. Add those first if you are an <strong>OrgAdmin</strong> or ask your OrgAdmin to do it.</p>
            <ol className="pt-2">
                <li>
                    <p>Go to your profile page by clicking on your pic in the header bar</p>
                </li>
                <li>
                    <p>Under the <span className="font-semibold text-orange-700">My Profile</span> Menu, go to Contacts</p>
                </li>
                <li>
                    <p>Click on the + icon button to add a <span className="font-semibold text-orange-700">new contact</span></p>
                </li>
            </ol>

        </div>
    ),

    contactDone: () => (
        <p className="text-xs text-gray-700 m-1 p-1 py-2 leading-5">
        You are all set with your <strong>Contact setup!</strong> Please check the <strong>Contacts</strong> under <span className="font-semibold text-orange-700">My Profile Menu</span> to see your contact details.
        </p>
    ),

}